import React, { useState, useEffect, useRef, useImperativeHandle, useContext } from 'react';
import Form, { ButtonItem, EmptyItem, FormRef, GroupItem, Item, Label, SimpleItem } from 'devextreme-react/form';
import { useFiltriDataSource, useAnteprimaDataSource } from '../../datasources/FilterBuilderDataSource';
import { useEntiDataSource } from '../../datasources/EntiDataSource';
import notify from 'devextreme/ui/notify';
import { useEmergenzeDataSource } from '../../datasources/EmergenzeDataSource';
import { useEmergenzaAssistitiDataSource } from '../../datasources/EmergenzaAssistitiDataSource';
import EmergenzaFilterPreviewPanel from './EmergenzaFilterPreviewPanel';
import { EmergenzaAssistitoAddByFilterDTO, EmergenzeApi } from '../../data';
import { FieldDataChangedEvent } from 'devextreme/ui/form';
import { apiConfiguration } from '../../apiConfig';
import { LoadPanel } from 'devextreme-react';
import TenantContext from '../../contexts/tenantContext';
import { showError } from '../../utils/errorHandling';

interface Props {
  emergenzaId: string
}

export type EmergenzaAssegnazioneCreateHandle = {
  save: () => Promise<boolean>;
}

const EmergenzaAssegnazioneCreate: React.ForwardRefRenderFunction<EmergenzaAssegnazioneCreateHandle, Props> = (props, ref) => {
  const { currentTenant } = useContext(TenantContext);
  const [formData, setFormData] = useState<EmergenzaAssistitoAddByFilterDTO>({});
  const formRef = useRef<FormRef>(null);
  const [loadPanelVisible, setLoadPanelVisible] = useState<boolean>(false);
  const [selectedFiltroId, setSelectedFiltroId] = useState<string>();
  const filtriDataSource = useFiltriDataSource();
  const entiDataSource = useEntiDataSource();

  const fieldDataChanged = (e: FieldDataChangedEvent) => {
    if (e.dataField === "filtroId")
      setSelectedFiltroId(e.value);
  };

  useImperativeHandle(ref, () => ({
    async save() {
      var validate = formRef.current?.instance().validate();
      console.log(validate);
      if (validate?.isValid) {
        const api = new EmergenzeApi(apiConfiguration);

        var data = formRef.current?.instance().option("formData");

        setLoadPanelVisible(true);

        try {
          await api.addEmergenzaAssistitiByFilter({
            tenantId: currentTenant.Id,
            emergenzaId: props.emergenzaId,
            emergenzaAssistitoAddByFilterDTO: data
          });

          return true;
        }
        catch (e) {
          showError(e);
          return false;
        }
        finally {
          setLoadPanelVisible(false);
        }

      }
      else {
        notify("Correggere gli errori di validazione", "error", 2000);
        return false;
      }
    }
  }));

  return (
    <React.Fragment>


      <Form id="form" ref={formRef} colCount={2} formData={formData} labelMode='floating' onFieldDataChanged={fieldDataChanged} >
        <Item dataField="filtroId" caption='Filtro' isRequired={true} editorType='dxLookup' editorOptions={{ dataSource: filtriDataSource, displayExpr: 'nome', valueExpr: 'id' }} />

        <Item dataField="enteId" caption='Ente' isRequired={true} editorType='dxLookup' editorOptions={{ dataSource: entiDataSource, displayExpr: 'nome', valueExpr: 'id' }} />
      </Form>
      <EmergenzaFilterPreviewPanel emergenzaIdToExclude={props.emergenzaId} filterId={selectedFiltroId} />

      <LoadPanel
        shadingColor="rgba(0,0,0,0.4)"
        position={{ of: '#form' }}
        visible={loadPanelVisible}
        showIndicator={true}
        shading={false}
        showPane={true}
        hideOnOutsideClick={false}
      />
    </React.Fragment>


    // <div className="assegnazione-container">
    //   <ResponsiveBox
    //     singleColumnScreen="sm"
    //     width="100%"
    //     height="100%"
    //   >
    //     <Row ratio={1}></Row>
    //     <Row ratio={2}></Row>

    //     <Col ratio={1}></Col>
    //     <Col ratio={1}></Col>

    //     {/* ================== COLONNA SINISTRA ================== */}

    //     {/* Selezione emergenza */}
    //     <Item>
    //       <Location row={0} col={0} />
    //       <div className="ente-selection">
    //         <h4>Seleziona un ente</h4>
    //         <SelectBox
    //           dataSource={useEntiDataSource()}
    //           displayExpr="nome"
    //           valueExpr="id"
    //           placeholder="Seleziona un ente..."
    //           value={selectedEnte}
    //           onValueChanged={(e) => setSelectedEnte(e.value)}
    //           width="100%"
    //         />
    //       </div>
    //     </Item>

    //     {/* DataGrid dei filtri */}
    //     <Item>
    //       <Location row={1} col={0} />
    //       <h4>Seleziona un filtro</h4>
    //       <DataGrid
    //         dataSource={filtriDataSource}
    //         showBorders={true}
    //         hoverStateEnabled={true}
    //         onSelectedRowKeysChange={e=> setSelectedFiltroId(e[0])}
    //         height={300}
    //       >
    //         <Selection 
    //           mode="single" 
    //           showCheckBoxesMode="always"
    //           selectAllMode="page"
    //         />
    //         <Column dataField="nome" caption="Nome" />
    //         <Column dataField="espressione" caption="Espressione" visible={false} />
    //       </DataGrid>
    //     </Item>

    //     {/* DataGrid delle persone */}
    //     <Item>
    //       <Location row={0} col={1} rowspan={2} />

    //      
    //     </Item>


    //   </ResponsiveBox>
    // </div>
  );
}

export default React.forwardRef(EmergenzaAssegnazioneCreate);